<script>
import "leaflet/dist/leaflet.css"
import { mapGetters } from "vuex"
import { LMap, LTileLayer, LGeoJson, LControl } from "vue2-leaflet"
import colorLerp from "color-lerp"
import canada_map from "../assets/geojson/canada.js"

const map = canada_map;
export default {
  name: "leaflet-map",
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LControl
  },
  data() {
    return {
      url: "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      options: {
        maxZoom: 8,
        minZoom: 3,
        zoomOffset: -1,
        tileSize: 512,
        attribution: "",
        id: "76design/cl6m825oj001k16pkro8eyott",
        accessToken:
          "pk.eyJ1IjoiNzZkZXNpZ24iLCJhIjoiY2w2bTd0aTQ5MGNncjNmbzlrc2ZpYzg3NiJ9.XZIGoAYiDw8fVZmc4AvTfQ",
      },
      zoom: 3,
      origin: [59.983529, -110.006282],
      map: map.canada,
      colors: [],
      range: [0, 50, 100, 500, 1000, 5000, 10000],
      legend_title: window.Drupal.t('Legend'),
      total_commitments: window.Drupal.t('Number of Youth Climate Actions Pledged'),
      locations: {
        Canada: window.Drupal.t('Canada'),
        Alberta: window.Drupal.t('Alberta'),
        'British Columbia': window.Drupal.t('British Columbia'),
        Manitoba: window.Drupal.t('Manitoba'),
        'New Brunswick': window.Drupal.t('New Brunswick'),
        'Newfoundland and Labrador': window.Drupal.t('Newfoundland and Labrador'),
        'Nova Scotia': window.Drupal.t('Nova Scotia'),
        'Northwest Territories': window.Drupal.t('Northwest Territories'),
        Nunavut: window.Drupal.t('Nunavut'),
        Ontario: window.Drupal.t('Ontario'),
        'Prince Edward Island': window.Drupal.t('Prince Edward Island'),
        Quebec: window.Drupal.t('Quebec'),
        Saskatchewan: window.Drupal.t('Saskatchewan'),
        Yukon: window.Drupal.t('Yukon')
      }
    };
  },
  created() {
    this.colors = this.colorRange
  },
  methods: {
    regionCommitments(prov) {
      return `<span><strong>${this.total_commitments}</strong> : ${this.commitment('sum_of_categories', prov.PRENAME)}</span>`
    },
    getCount(prov) {
      return this.commitment('sum_of_categories', prov.PRENAME)
    },
    getRangeColor(commitment) {
      if (!commitment) return "#EDFEFF"

      for (let i = 0; i < this.range.length; i++) {
        if (commitment >= this.range[i] && commitment < this.range[i + 1]) return this.colors[i]
        else if (commitment >= this.range[this.range.length - 1]) return this.colors[this.range.length - 1]
      }
    },
  },
  computed: {
    ...mapGetters({
      youthCommitments: 'getYouthCommitments',
      commitment: 'getCommitment',
      commitments: 'getCommitments'
    }),
    boundaryOptions() {
      return {
        onEachFeature: this.onEachBoundary,
      };
    },
    colorRange() {
      return colorLerp("#EDFEFF", "#00B7C4", 7, 'hex')
    },
    buildLegend() {
      const group = [];
      const color = this.colors;
      for (let i = 0; i < this.range.length; i++) {
        group.push(`<li><i style="background:${color[i]};display: inline-block;width: 1rem;height: 1rem;margin-right: 0.5rem;"></i>${this.range[i] + (this.range[i + 1] ? ' - ' + this.range[i + 1] : '+')} </li>`)
      }
      return group.join('')
    },
    boundaryStyle() {
      return () => {
        return {
          weight: 4,
          color: "#00B7C4",
          opacity: 0.4,
          fill: true,
          fillColor: "#EDFEFF",
          fillOpacity: 0.4,
        };
      };
    },
    onEachBoundary() {
      const commitments = this.commitments.sum_of_categories
      return (feature, layer) => {
        layer.on({
          click: () => {
            this.$root.$refs.commitments.updateLocation(feature.properties.PRENAME)
          },
        }),
          layer.setStyle({
            weight: 4,
            color: "#00B7C4",
            opacity: 0.4,
            fill: true,
            fillColor: this.getRangeColor(commitments[`${feature.properties.PRENAME}`]),
            fillOpacity: 0.5,
          }),
          layer.bindTooltip(
            `<div class="action-tracker-tooltip"> 
              <h2>${this.locations[feature.properties.PRENAME]}</h2>
              ${this.regionCommitments(feature.properties)}
              </div>`,
            { permanent: false, sticky: true }
          );
      };
    },
  },
};
</script>
<template>
  <div id="map">
    <LMap ref="map" style="height: 500px" :zoom="zoom" :center="origin">
      <LTileLayer :url="url" :options="options" />
      <LControl position="bottomright">
        <div class="legend">
          <h2>{{ this.legend_title }}</h2>
          <ul v-html="buildLegend"></ul>
        </div>
      </LControl>
      <LGeoJson :geojson="map" :options="boundaryOptions" />
    </LMap>
  </div>
</template>
<style>
#map {
  min-height: 500px;
}

.action-tracker-tooltip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  gap: 0.3rem;
}

.action-tracker-tooltip h2 {
  font-size: 0.9rem !important;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.action-tracker-tooltip h2,
.legend h2 {
  font-family: futuramedium !important;
  color: #000;
}

.legend {
  background: rgba(239, 239, 239, 0.7);
  padding: 0.2rem 1rem;
  border-radius: 1rem;

}

.legend h2 {
  font-size: 1.1rem !important;
  margin: 0.3rem 0;
}

.legend ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  padding-left: 0 !important;
  margin-left: 0 !important;
}
</style>
